/* eslint-disable no-console */
import {Col, Divider, Form, Row, Select} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import ListViewMapViewToggle from '../../../../components/ListViewMapViewToggle/ListViewMapViewToggle';
import Loader from '../../../../components/Loader/Loader';
import FacilityTable from '../../../../components/Table/FacilityTable';
import cityJSON from '../../../../services/modules/JSON/cityJSON';
import country from '../../../../services/modules/JSON/country';
import facilityType from '../../../../services/modules/JSON/facilityType';
import hotelRating from '../../../../services/modules/JSON/rating';
import restaurantType from '../../../../services/modules/JSON/restuarantType';
import statesJSON from '../../../../services/modules/JSON/statesJSON';
import activeFacilityCount from '../../../../services/modules/OM/activeFacilityCount';
import useCompanyStore from '../../../../store/companyStore/companyDetailsStore';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';
import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {rowGutter} from '../Constants/Common';
import {OPKey} from '../orgInfo/constants/orgProfileKeyLabel';

const FacilityInfo: React.FC = () => {
  const [isListView, setIsListView] = useState(true);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');
  const companyDetails = useCompanyStore.getState().companyDetails;

  // const [toReset, setToReset] = useState(false);
  const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    setSelectedYear(currentYear);
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
  }, []);

  useEffect(() => {
    Promise.all([
      activeFacilityCount(),
      country(),
      statesJSON(),
      cityJSON(),
      facilityType(),
      companyDetails?.[OPKey.SUB_CATEGORY] === 6 && hotelRating(),
      companyDetails?.[OPKey.SUB_CATEGORY] === 8 && restaurantType()
    ])
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      {searchParam.get('selectedYear') && (
        <Row gutter={rowGutter} style={{margin: '10px 8px'}}>
          <Col
            className="gutter-row"
            span={4}
            style={{padding: '0px 8px 0px 16px'}}
          >
            <Form.Item label="Year" labelCol={{span: 24}}>
              <Select
                placeholder="Year"
                value={selectedYear}
                options={firstYear}
                size="middle"
                onChange={(e) => {
                  setSelectedYear(e);
                  searchParam.set('selectedYear', e);
                  setSearchParams(searchParam);
                }}
              />
            </Form.Item>
          </Col>
          <Col
            className="gutter-row"
            span={10}
            style={{margin: '2.48rem 0rem'}}
          >
            <ListViewMapViewToggle setIsListView={setIsListView} />
          </Col>
        </Row>
      )}
      {/* <div
        style={{
          marginTop: '1.5rem',
          marginBottom: '1rem',
          font: 'normal normal 500 14px/22px Montserrat',
          letterSpacing: '0px',
          color: '#000000',
          opacity: 1
        }}
      >
        Set Filters
      </div> */}

      {/* <FacilitySelectFilter
        setDataSource={setDataSource}
        setIsListView={setIsListView}
        setToReset={setToReset}
        toReset={toReset}
        setSelectedYear={setSelectedYear}
      /> */}
      <Divider orientationMargin="0" className="divider" />
      <FacilityTable
        isListView={isListView}
        dataSource={dataSource}
        setDataSource={setDataSource}
        selectedYear={selectedYear}
      />
    </>
  );
};

export default FacilityInfo;
